import { useQueryParam } from '../../../../shared/router/useQueryParam';

export const usePromoCodeFromQuery = () => ({
	queryPromoCode: useQueryParam('promocode') || '',
	queryOfferId: useQueryParam('offerid') || '',
});
